import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { identityModel } from '../../../redux-modules/base/models';

function Checkbox({
  id,
  item,
  value,
  label,
  handleChange,
}) {
  return (
    <div className="checkbox">
      <input
        id={id}
        type="checkbox"
        value={item.key}
        onChange={handleChange}
        checked={_.get(value, item.key, false)}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
}

export { Checkbox };

Checkbox.propTypes = {
  id: identityModel.isRequired,
  item: PropTypes.shape({
    key: identityModel.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.shape({}).isRequired,
  label: PropTypes.string.isRequired,
};
